import { makeStyles } from '@material-ui/core'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    width: 40,
    height: 40,
    borderRadius: '50%',
    position: 'fixed',
    bottom: 30,
    right: 30,
    display: 'inline-block',
    textAlign: 'center',
    transition: 'background-color .3s,opacity .5s,visibility .5s',
    zIndex: 2100,
    visibility: 'hidden',
    opacity: 0,
    cursor: 'pointer'
  },
  rootForMobileSize: {
    width: 60,
    height: 60
  },
  show: {
    opacity: 1,
    visibility: 'visible'
  },
  icon: {
    position: 'absolute',
    top: 10,
    left: 10,
    width: 20,
    height: 20,
    color: theme.palette.background.default
  },
  iconForMobileSize: {
    top: 14,
    width: 40,
    height: 30
  }
}))

export default useStyles
